import { img } from "@/lib/images";

// ============================================================
// Alte Bali-Info-Fotos (balivwtour.com) im eigenen Speicher
// ------------------------------------------------------------
// Die Fotos der früheren Seite liegen jetzt im Supabase-Bucket
// "site-images" unter:
//   balivwtour/bali-info/plants-and-fruits/…       (Pflanzen & Früchte)
//   balivwtour/bali-info/spices/…                  (Gewürze)
//
// Der Ordner "balivwtour" trennt die Inhalte der alten Seite
// von den Villa-Kompiang-Fotos im selben Bucket.
//
// Die Dateinamen bleiben gleich, nur das Kürzel "_large" fällt weg.
// Diese Datei rechnet eine alte Adresse in den neuen Pfad um.
// ============================================================

const OLD_BASE = "https://www.balivwtour.com/images_large/";

const FOLDER_MAP: Record<string, string> = {
  fruits_and_plants_of_bali_large: "balivwtour/bali-info/plants-and-fruits",
  spices_of_bali_large: "balivwtour/bali-info/spices",
};

/** Neuer Pfad im eigenen Speicher (ohne Domain), oder null wenn unbekannt. */
export function baliPhotoPath(url: string): string | null {
  if (!url.startsWith(OLD_BASE)) return null;
  const rest = url.slice(OLD_BASE.length);
  const slash = rest.indexOf("/");
  if (slash < 0) return null;
  const folder = rest.slice(0, slash);
  const file = rest.slice(slash + 1);
  const target = FOLDER_MAP[folder];
  if (!target || !file) return null;
  return `${target}/${file.replace(/_large\.jpg$/, ".jpg")}`;
}

/** Vollständige Adresse im eigenen Speicher – oder die alte Adresse als Notlösung. */
export function baliPhotoUrl(url: string): string {
  const path = baliPhotoPath(url);
  return path ? img(path) : url;
}